import { FlexDiv } from 'components/generic/HomePageComponents'
import FeaturedBanner from 'components/base/FeaturedBanner'
import ListingCardHeading from './ListingCardHeading'
import ListingCardLocationStatus from './ListingCardLocationStatus'
import ListingDescription from './ListingDescription'
import ListingDetails from './ListingDetails'

import {
  ListingCardContainer,
  ListingImg,
  FeaturedBannerContainer,
  ListingImgAndBannerContainer,
  ListingInfoContainer,
} from './Styled'

const ListingCard = (props) => {
  const {
    listing: {
      path,
      name,
      avatar,
      featured,
      ownerName,
      city,
      state,
      user,
      description,
      payRate,
      years_experience,
    },
  } = props

  return (
    <ListingCardContainer href={path}>
      <FlexDiv flexDrection='column' alignItems='center'>
        <FlexDiv>
          <ListingImgAndBannerContainer mr={{ _: 0, tablet: '1rem' }}>
            <ListingImg
              src={avatar.large_url}
              alt={name}
              width='100px'
              height='100px'
              effect='blur'
            />
            <FeaturedBannerContainer>{featured && <FeaturedBanner />}</FeaturedBannerContainer>
          </ListingImgAndBannerContainer>
          <ListingInfoContainer>
            <ListingCardHeading listingOwnerName={ownerName} headline={name} />
            <ListingCardLocationStatus
              locationName={`${city.name}, ${state.name}`}
              lastOnline={user && user.last_online}
              listingPath={path}
            />
            <ListingDescription description={description} />
            <ListingDetails payRate={payRate} yearsExp={years_experience} />
          </ListingInfoContainer>
        </FlexDiv>
      </FlexDiv>
    </ListingCardContainer>
  )
}

export default ListingCard
